import { TaskInstancePagingList } from './task-instance-paging-list';

/**
 * REST API model
 */
export class TaskInstanceList {
  list?: TaskInstancePagingList;
  constructor(input?: any) {
    if (input) {
      Object.assign(this, input);
      this.list = input.list ? new TaskInstancePagingList(input.list) : undefined;
    }
  }
}
